import React from "react";
import CustomHeading from "../../../constants/CustomHeading";
const CourseDomainReport = () => {
  return (
    <>
    	<CustomHeading title="Course Domain Report"/>
    </>
  );
};

export default CourseDomainReport;
